export default {
    methods: {
        clearTooltips: () => {
            $('div.tooltip[role="tooltip"]').remove();
        },
    },
    updated() {
        $(function () {
            $("[data-toggle='tooltip']").tooltip({html : true});
        });

        $(function () {
            $(".tooltip-more").tooltip();
        });
    }
}
